module.exports = __webpack_public_path__ + "static/protection-indemnity-insurance-marine-liability-22c1ea13fd227ae7a63498064f8e8593.svg";